import { fromJS } from 'immutable';

import colors from 'styles/colors';

import AvailableIcon from 'assets/Checkmark';
import FuelIcon from 'assets/VehicleStatusIcons/FuelIcon';
import GroundedIcon from 'assets/VehicleStatusIcons/GroundedIcon';
import MaintenanceIcon from 'assets/VehicleStatusIcons/MaintenanceIcon';
import MissingUnitIcon from 'assets/VehicleStatusIcons/MissingUnitIcon';
import MissingKeysIcon from 'assets/VehicleStatusIcons/MissingKeysIcon';
import SoldIcon from 'assets/VehicleStatusIcons/SoldIcon';
import NeedsWashIcon from 'assets/VehicleStatusIcons/ToCleanIcon';

export const BASE_VEHICLE_STATUSES = {
  AVAILABLE: {
    id: '1',
    name: 'available',
    translationId: 'services.Vehicles.statuses.noBlocker',
    icon: <AvailableIcon color={colors.green} />,
  },
  LOW_FUEL: {
    id: '8',
    name: 'lowFuel',
    translationId: 'services.Vehicles.statuses.lowFuel',
    icon: <FuelIcon color={colors.newWarning} />,
  },
  NEEDS_WASH: {
    id: '9',
    name: 'needsWash',
    translationId: 'services.Vehicles.statuses.needsWash',
    icon: <NeedsWashIcon color={colors.newWarning} />,
  },
  GROUNDED: {
    id: '0',
    name: 'grounded',
    translationId: 'services.Vehicles.statuses.grounded',
    icon: <GroundedIcon color={colors.red} />,
  },
  MAINTENANCE: {
    id: '3',
    name: 'maintenance',
    translationId: 'services.Vehicles.statuses.maintenance',
    icon: <MaintenanceIcon color={colors.red} />,
  },
  SOLD: {
    id: '4',
    name: 'sold',
    translationId: 'services.Vehicles.statuses.sold',
    icon: <SoldIcon color={colors.red} />,
  },
  MISSING_UNIT: {
    id: '6',
    name: 'missingUnit',
    translationId: 'services.Vehicles.statuses.missingUnit',
    icon: <MissingUnitIcon color={colors.red} />,
  },
  MISSING_KEYS: {
    id: '7',
    name: 'missingKeys',
    translationId: 'services.Vehicles.statuses.missingKeys',
    icon: <MissingKeysIcon color={colors.red} />,
  },
};

export const EXTRA_VEHICLE_STATUSES = {
  AVAILABLE: {
    id: '1',
    name: 'available',
    translationId: 'services.Vehicles.statuses.available',
  },
  ON_LOAN: {
    id: '2',
    name: 'onLoan',
    translationId: 'services.Vehicles.statuses.onLoan',
  },
  RESERVED: {
    id: '5',
    name: 'reserved',
    translationId: 'services.Vehicles.statuses.reserved',
  },
  ON_HOLD: {
    id: '10',
    name: 'onHold',
    translationId: 'services.Vehicles.statuses.onHold',
  },
};

export const VEHICLE_AVAILABILITIES = {
  AVAILABLE: {
    id: '0',
    name: 'available',
    translationId: 'services.Vehicles.statuses.available',
  },
  RESERVED: {
    id: '1',
    name: 'reserved',
    translationId: 'services.Vehicles.statuses.reserved',
  },
  ON_LOAN: {
    id: '2',
    name: 'onLoan',
    translationId: 'services.Vehicles.statuses.onLoan',
  },
};

export const VEHICLE_STATUSES = {
  ...BASE_VEHICLE_STATUSES,
  ...EXTRA_VEHICLE_STATUSES,
};

const allVehicleStatuses = fromJS(VEHICLE_STATUSES)
  .toList()
  .map((value) =>
    fromJS({
      value: value.get('id'),
      id: value.get('name'),
      renderedValue: {
        translationId: value.get('translationId'),
      },
      // @ts-expect-error TS(2339): Property 'get' does not exist on type 'unknown'.
      icon: value.get('icon', undefined),
    })
  );

const reservationVehicleStatuses = fromJS(BASE_VEHICLE_STATUSES)
  .toList()
  .map((value) =>
    fromJS({
      value: value.get('id'),
      id: value.get('name'),
      renderedValue: {
        translationId: value.get('translationId'),
      },
      icon: value.get('icon', undefined),
    })
  );

// All statuses, but only "Available" can be selected
const onlyAvailableStatus = fromJS(VEHICLE_STATUSES).mapEntries(([key, value]) =>
  // @ts-expect-error Type 'Map<"id" | "icon" | "value" | "renderedValue" | "disabled", any>' is not assignable to type '[unknown, unknown]'.
  fromJS({
    // @ts-expect-error Property 'id' does not exist on type 'Map<"id" | "translationId" | "name" | "icon", string | Map<keyof Element, ...
    value: value.id,
    // @ts-expect-error Property 'name' does not exist on type 'Map<"id" | "translationId" | "name" | "icon", string | Map<keyof Element, ...
    id: value.name,
    disabled: key !== 'AVAILABLE',
    renderedValue: {
      // @ts-expect-error Property 'translationId' does not exist on type 'Map<"id" | "translationId" | "name" | "icon", string | Map<keyof Element, ...
      translationId: value.translationId,
    },
    // @ts-expect-error Property 'icon' does not exist on type 'Map<"id" | "translationId" | "name" | "icon", string | Map<keyof Element, ...
    icon: value.icon,
  })
);

export const DROPDOWN_FORMATTED_VEHICLE_STATUSES = {
  ALL: allVehicleStatuses,
  RESERVATION_ENABLED: reservationVehicleStatuses,
  AVAILABLE_ONLY: onlyAvailableStatus,
};

export const VEHICLE_AVAILABILITY_TRANSLATION = fromJS({
  0: { translationId: 'services.Vehicles.availabilities.available' },
  1: { translationId: 'services.Vehicles.availabilities.reserved' },
  2: { translationId: 'services.Vehicles.availabilities.onLoan' },
});

export const VEHICLE_STATUS_TRANSLATIONS = {
  1: { translationId: 'services.Vehicles.statuses.noBlocker' },
  0: { translationId: 'services.Vehicles.statuses.grounded' },
  3: { translationId: 'services.Vehicles.statuses.maintenance' },
  4: { translationId: 'services.Vehicles.statuses.sold' },
  6: { translationId: 'services.Vehicles.statuses.missingUnit' },
  7: { translationId: 'services.Vehicles.statuses.missingKeys' },
  8: { translationId: 'services.Vehicles.statuses.lowFuel' },
  9: { translationId: 'services.Vehicles.statuses.needsWash' },
  null: { translationId: 'services.Vehicles.statuses.unknown' },
  undefined: { translationId: 'services.Vehicles.statuses.unknown' },
};

export const VEHICLE_STATUS_EXTRA_TRANSLATIONS = {
  1: { translationId: 'services.Vehicles.statuses.available' },
  11: { translationId: 'services.Vehicles.statuses.groundedReserved' },
  12: { translationId: 'services.Vehicles.statuses.reserved' },
  14: { translationId: 'services.Vehicles.statuses.maintenanceReserved' },
  15: { translationId: 'services.Vehicles.statuses.soldReserved' },
  17: { translationId: 'services.Vehicles.statuses.missingUnitReserved' },
  18: { translationId: 'services.Vehicles.statuses.missingKeysReserved' },
  19: { translationId: 'services.Vehicles.statuses.lowFuelReserved' },
  20: { translationId: 'services.Vehicles.statuses.needsWashReserved' },
  22: { translationId: 'services.Vehicles.statuses.groundedOnLoan' },
  23: { translationId: 'services.Vehicles.statuses.onLoan' },
  25: { translationId: 'services.Vehicles.statuses.maintenanceOnLoan' },
  26: { translationId: 'services.Vehicles.statuses.soldOnLoan' },
  28: { translationId: 'services.Vehicles.statuses.missingUnitOnLoan' },
  29: { translationId: 'services.Vehicles.statuses.missingKeysOnLoan' },
  30: { translationId: 'services.Vehicles.statuses.lowFuelOnLoan' },
  31: { translationId: 'services.Vehicles.statuses.needsWashOnLoan' },
};

// Only statuses that are relevant for calendar view
export const VEHICLE_STATUS_CALENDAR = {
  0: {
    translationId: 'services.Vehicles.statuses.grounded',
    icon: GroundedIcon,
  },
  3: {
    translationId: 'services.Vehicles.statuses.maintenance',
    icon: MaintenanceIcon,
  },
  4: {
    translationId: 'services.Vehicles.statuses.sold',
    icon: SoldIcon,
  },
  6: {
    translationId: 'services.Vehicles.statuses.missingUnit',
    icon: MissingUnitIcon,
  },
  7: {
    translationId: 'services.Vehicles.statuses.missingKeys',
    icon: MissingKeysIcon,
  },
  8: {
    translationId: 'services.Vehicles.statuses.lowFuel',
    icon: FuelIcon,
  },
  9: {
    translationId: 'services.Vehicles.statuses.needsWash',
    icon: NeedsWashIcon,
  },
};

export const VEHICLE_BASE_STATUS_TRANSLATIONS_REACT_SELECT = [
  {
    value: null,
    label: { translationId: 'services.Vehicles.statuses.unknown' },
  },
  {
    value: undefined,
    label: { translationId: 'services.Vehicles.statuses.unknown' },
  },
  {
    value: 0,
    label: { translationId: 'services.Vehicles.statuses.grounded' },
  },
  {
    value: 3,
    label: { translationId: 'services.Vehicles.statuses.maintenance' },
  },
  {
    value: 4,
    label: { translationId: 'services.Vehicles.statuses.sold' },
  },
  {
    value: 6,
    label: { translationId: 'services.Vehicles.statuses.missingUnit' },
  },
  {
    value: 7,
    label: { translationId: 'services.Vehicles.statuses.missingKeys' },
  },
  {
    value: 8,
    label: { translationId: 'services.Vehicles.statuses.lowFuel' },
  },
  {
    value: 9,
    label: { translationId: 'services.Vehicles.statuses.needsWash' },
  },
];

export const VEHICLE_EXTRA_STATUS_TRANSLATIONS_REACT_SELECT = [
  {
    value: 1,
    label: { translationId: 'services.Vehicles.statuses.available' }, // TODO(Greg): change to noStatus once backend is deployed
  },
  {
    value: 2,
    label: { translationId: 'services.Vehicles.statuses.onLoan' }, // TODO(Greg): remove once backend is deployed
  },
  {
    value: 5,
    label: { translationId: 'services.Vehicles.statuses.reserved' }, // TODO(Greg): remove once backend is deployed
  },
  {
    value: 10,
    label: { translationId: 'services.Vehicles.statuses.onHold' }, // TODO(Greg): remove once backend is deployed
  },
];

export const VEHICLE_STATUS_TRANSLATIONS_REACT_SELECT = [
  ...VEHICLE_BASE_STATUS_TRANSLATIONS_REACT_SELECT,
  ...VEHICLE_EXTRA_STATUS_TRANSLATIONS_REACT_SELECT,
];

export const VEHICLE_STATUS_TRANSLATIONS_REACT_SELECT_WITH_RESERVATION = [
  ...VEHICLE_BASE_STATUS_TRANSLATIONS_REACT_SELECT,
  {
    value: 1,
    label: { translationId: 'services.Vehicles.statuses.noBlocker' },
  },
];

export const VEHICLE_ALL_STATUS_LIST_MAP = fromJS({
  ...VEHICLE_STATUS_TRANSLATIONS,
  ...VEHICLE_STATUS_EXTRA_TRANSLATIONS,
});

export const VEHICLE_STATUS_LIST_MAP = fromJS(VEHICLE_STATUS_TRANSLATIONS);
